import './Text';
let {
  Tooltip
} = L;
/**
 * 
 */
L.CanvasTooltip = Tooltip.extend({
  /**
   * 
   * @param {*} map 
   */
  onAdd(map) {
    this._zoomAnimated = map._zoomAnimated;
    /**
     * 
     */
    if (!this._label) {
      this._initLayout();
    }
    /**
     * 
     */
    if (map._fadeAnimated) { // 变透明

    }
    /**
     * 
     */
    this._label.addTo(map);
    this.update();

    if (map._fadeAnimated) { // 变不透明

    }

    this.bringToFront();
  },
  /**
   * 
   * @param {*} map 
   */
  onRemove(map) {
    this._label && this._label.remove();
  },
  /**
   * @override
   */
  _initLayout() {
    let {
      _source
    } = this;
    // 
    let showBackground;
    let latlng;
    if (_source._latlng) {
      showBackground = true;
      latlng = _source._latlng;
    } else {
      latlng = _source.getCenter();
    }
    if (_source) {
      // 临时处理
      _source.on('dragstart', e => {
        _source.closeTooltip();
      }).on('dragend', e => {
        _source.openTooltip();
      })
    }

    //
    this._label = L.text(latlng, this._text, this.options = T.merge({
      font: "13px 新宋体",
      color: "#000",
      fill: true,
      anchor: true, // 锚
      textAlign: "left", // 水平居中
      direction: 'top',
      outlineColor: '#000',
      backgroundColor: '#fff', // 背景框
      showBackground
    }, this.options));
  },
  /**
   * @override
   * @param {*} pos 
   */
  _setPosition(pos) {

  },
  /**
   * @override
   */
  setLatLng(latlng) {
    Tooltip.prototype.setLatLng.call(this, latlng)
    this._label && this._label.setLatLng(this._latlng)
  },
  /**
   * 
   */
  _updatePosition() {
    this._label && this._label.setLatLng(this._latlng)
  },
  /**
   *  @override
   */
  bringToFront() {
    this._label.bringToFront();
  },
  /**
   * 
   */
  _updateContent: function () {
    if (!this._content) {
      return;
    }

    var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
    this._label.setContent(content);
    this.fire('contentupdate');
  },
  /**
   * 
   */
  update: function () {
    if (!this._map) {
      return;
    }

    this._updateContent();
    this._updatePosition();
  },
})



// WEBPACK FOOTER //
// ./src/feature/CanvasTooltip.js